import React from 'react';

import { InputLabel } from '@material-ui/core';
import { openRealignModalAction } from 'components/RealignModal/redux/actions';
import { useDispatch } from 'react-redux';
import AlignmentSection from 'screens/common/sidepanel/Alignment';
import { VerticallyAlignedFlexContainer } from 'styles/common';

import { RealignSvgIcon } from 'constants/icons';
import theme from 'constants/theme';

import { Typography12 } from 'uiToolkit/Typography';

import { useObjectiveSidepanel } from '../context/ObjectiveSidePanelContext';

const ObjectiveAlignment = ({
  objectiveTimeBoundId,
  isAlignmentAtParentLevel = false,
  selectedTimeBoundPeriod,
  parentUuid,
}) => {
  const dispatch = useDispatch();
  const { setParentTag, state, setTimeboundDetails } = useObjectiveSidepanel();
  const { objectiveTimeBoundId: contextObjectiveTimeBoundId } = state ?? {};
  const { id } = state?.parentTag ?? {};

  const onClickHandler = () => {
    dispatch(
      openRealignModalAction({
        selectedObjective: {
          timeBoundDetails: selectedTimeBoundPeriod,
          objectiveId: id ?? parentUuid,
        },
        realignId: contextObjectiveTimeBoundId ?? objectiveTimeBoundId,

        onSelect: (tag) => {
          setParentTag(tag?.objectiveId, tag?.objectiveTimeBoundId, tag?.postCardId);
        },
        selectedTimeBoundPeriod: state.timeBoundDetails,
        showAlignAsParent: true,
        setTimeboundDetails,
        isObjectiveSidePanel: true,
      })
    );
  };

  return (
    <InputLabel htmlFor="objective-name-field" style={{ marginBottom: '1rem' }}>
      <VerticallyAlignedFlexContainer>
        <Typography12 bottomGutter={0.5}>Alignment</Typography12>
        <VerticallyAlignedFlexContainer style={{ marginLeft: 'auto', cursor: 'pointer' }} onClick={onClickHandler}>
          <RealignSvgIcon
            containerSize="fixed24px"
            circular
            size="fixed14px"
            color="primary"
            style={{ border: `1px solid ${theme.palette.icons.blue}`, marginRight: '0.5rem' }}
          />

          <Typography12 style={{ marginLeft: 'auto' }} color="primary" bottomGutter={0.5}>
            Realign
          </Typography12>
        </VerticallyAlignedFlexContainer>
      </VerticallyAlignedFlexContainer>
      <AlignmentSection
        goalDetails={{
          subObjective: {
            objectiveTimeBoundId: contextObjectiveTimeBoundId ?? objectiveTimeBoundId,
          },
        }}
        isAlignmentAtParentLevel={!id}
        showHeader={false}
        setTimeboundDetails={setTimeboundDetails}
        // updateGoal={updateGoal}
        // disabled={!goalDetails?.actions?.edit.canPerform}
        // reason={goalDetails?.actions?.edit.reason}
      />
    </InputLabel>
  );
};

export default ObjectiveAlignment;
